import EntityClassRequest from '../../model/entity-class-request';
import { initFilterExpression } from '../../model/filterExpressionUtils';

const parentDisplayAttributeName = 'ParentDisplayString';

MxObjectPickerCtrl.$inject = [
	'$scope',
	'$q',
	'$element',
	'$timeout',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.shell.KeyboardNavigationService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'$attrs',
];

function MxObjectPickerCtrl(
	$scope,
	$q,
	$element,
	$timeout,
	mxEntityService,
	i18n,
	dialogOpener,
	columnDefinition,
	externalServiceManager,
	keyboardNavigationService,
	contentWidgetService,
	$attrs
) {
	const vm = this;

	let filter;
	let resetFilter;

	let _resetFilterActive = false;
	let _loadItemsCount = 6;
	let _pickerCtrl = null;
	let useObjectId;
	let widgetId;

	vm.$onInit = function () {
		useObjectId = vm.useObjectId && vm.useObjectId.toLowerCase() === 'true';
		_pickerCtrl = null;
		widgetId = contentWidgetService.getWidgetIdForControl(this, $scope);
		vm.loadItems = loadItems;
		vm.notFoundClick = notFoundClick;
		vm.navigateSelectedItem = navigateSelectedItem;
		if (vm.noBrowseLookup !== 'true') {
			vm.browseLookup = browseLookup;
		}
		vm.getModel = function () {
			return vm.model;
		};

		registerHotkeys($scope, $element, vm, keyboardNavigationService, i18n);

		if (vm.parentExpression) {
			vm.itemDetailsField = parentDisplayAttributeName;
		}

		// Checks model on an unsuitable value (e.g. Guid.Empty) that can be set on initialization, or later through a service.
		var _isModelWithEmptyValue = function () {
			if (vm.model !== null) {
				var guidEmpty = mx.components.Utils.guidEmpty();

				if (vm.model === guidEmpty) {
					return true;
				}
			}

			return false;
		};

		if (_isModelWithEmptyValue()) {
			vm.model = null;
		}

		vm.setAdditionalOutputs = function (item) {
			vm.objectId = item ? item['Sys-ObjectId'] || item.ObjectId : null;
			vm.displayString = item ? item.DisplayString : null;
		};

		vm.onChange = function (onChangeData) {
			vm.setAdditionalOutputs(vm.selectedItem, onChangeData);
			if (_isModelWithEmptyValue()) {
				vm.model = null;
			}
		};

		const initFilter = (propertyName) => {
			return initFilterExpression({
				propertyName,
				controlMxAtId: vm.mxAtId,
				$scope,
				$attrs,
				$element,
				controller: vm,
				onChanged: onFilterChanged,
			});
		};

		filter = initFilter('filter-expression');
		resetFilter = initFilter('reset-filter-expression');

		vm.notFoundDescriptor = null;

		if (resetFilterIsAllowed(vm.allowResetFilter)) {
			vm.notFoundDescriptor = {
				buttonClick: vm.notFoundClick,
				buttonText: i18n.get('solutionBuilderAgent.components.mx-object-picker.showAll'),
			};
		}

		vm.loadMoreClick = loadMoreClick;
		vm.loadMoreConfig = {
			onClick: vm.loadMoreClick,
			title: i18n.get('shell.common.showMore'),
		};

		vm.internalOnBlur = function ($event) {
			if (typeof vm.onBlur === 'function') {
				vm.onBlur($event);
			}

			_loadItemsCount = 6;
		};
	};

	function onFilterChanged() {
		if (_pickerCtrl) {
			_pickerCtrl.resetItemsCache();
		}
	}

	function resetFilterIsAllowed(resetFilterString) {
		return resetFilterString && resetFilterString.toLowerCase() === 'true';
	}

	vm._getFragmentDescriptorsInBatch = function (entityClassName, id, parentExpression, useObjectId, rootElement, includeRoot, displayExpression, dataQueryName) {
		return mxEntityService.getFragmentDescriptorsInBatch(
			entityClassName,
			id,
			parentExpression,
			useObjectId,
			rootElement,
			includeRoot,
			widgetId,
			displayExpression || vm.displayExpression,
			dataQueryName
		);
	};

	function navigateSelectedItem(item) {
		dialogOpener.openPreview(item, undefined, undefined, vm.parentViewController && vm.parentViewController.mxView);
	}

	async function openLookupDialog(selectedItems) {
		const parentView = vm.parentViewController && vm.parentViewController.mxView;
		// OuterContext is necessary for PBI 164616 (prefilling in CoRu).
		const presetFields =
			parentView && parentView.locals && parentView.locals.dataModel
				? {
						Context: {
							OuterContext: parentView.locals.dataModel.Context,
						},
				  }
				: undefined;

		const items = await dialogOpener.selectObjects(
			vm.entityClassName,
			vm.label,
			selectedItems,
			filter,
			vm.columnDefinition,
			vm.isMultipleSelection,
			false,
			vm.allowedTypes,
			parentView,
			resetFilterIsAllowed(vm.allowResetFilter),
			resetFilter,
			false,
			presetFields
		);
		if (useObjectId) {
			items.forEach((item) => (item.Id = item._id));
		}

		return await updateDisplayExpression(items);
	}

	async function browseLookup(selectedItems) {
		if (!vm.entityClassName && !vm.columnDefinition) {
			return selectedItems;
		}
		selectedItems = Array.isArray(selectedItems) ? selectedItems : selectedItems === null || typeof selectedItems === 'undefined' ? [] : [selectedItems];

		if (vm.isMultipleSelection && vm.relationName && !vm.reverseRelationIsSet) {
			const extraData = {};
			const requestData = new EntityClassRequest(vm.entityClassName, null, 1, vm.columnDefinition);
			requestData.relationName = vm.relationName;

			await mxEntityService.getFragmentDescriptors(requestData, null, extraData);
			vm.entityClassName = extraData.EntityClass;
			vm.reverseRelationIsSet = true;
		}

		return await openLookupDialog(selectedItems);
	}

	function getItemDetails(pickerModel, item) {
		$timeout(function () {
			if (vm.mxForm && vm.mxForm.displayStrings && !vm.displayExpression && !vm.isMultipleSelection) {
				var result = vm.mxForm.displayStrings.filter(function (displayStringInfo) {
					return item.Id === displayStringInfo.Id;
				});

				if (result.length === 1) {
					angular.extend(item, result[0]);
					setNewSelectedItem(item);
					return;
				}
			}
			if (item.Id) {
				if (vm.entityClassName) {
					if (externalServiceManager.isService(vm.entityClassName)) {
						externalServiceManager.getObjectInfo(vm.entityClassName, item.Id).then(function (res) {
							item.DisplayString = res.DisplayString;
						});
					} else {
						vm._getFragmentDescriptorsInBatch(
							vm.entityClassName,
							item.Id,
							vm.parentExpression,
							useObjectId,
							undefined,
							undefined,
							vm.displayExpression,
							vm.columnDefinition
						).then(updateItem);
					}
				} else if (vm.columnDefinition) {
					columnDefinition.getGridDefinitionByName(vm.columnDefinition).then(function (columnDef) {
						externalServiceManager.getObjectInfo('service_' + columnDef.Service, item.Id).then(function (res) {
							item.DisplayString = res.DisplayString;
							setNewSelectedItem(item);
						});
					});
				}
			}
		});

		function setNewSelectedItem(_item) {
			pickerModel.selectedItem = angular.copy(_item);
			vm.setAdditionalOutputs(_item);
		}

		function updateItem(data) {
			if (pickerModel.selectedItem) {
				setNewSelectedItem(data);
			} else {
				angular.extend(item, data);
			}
		}
	}

	function notFoundClick(returnInitial) {
		_resetFilterActive = !returnInitial;
	}

	function loadMoreClick() {
		_loadItemsCount += 5;
	}

	function getClassNameByColumnDefinition() {
		return columnDefinition
			.getGridDefinitionByName(vm.columnDefinition)
			.then(function (columnDef) {
				var entityClassName = vm.entityClassName;

				if (columnDef.ServiceInfo) {
					entityClassName = 'service_' + columnDef.Service;
				} else if (!entityClassName) {
					entityClassName = columnDef.SchemaClassName;
				}
				return entityClassName;
			})
			.catch(function () {
				return vm.entityClassName;
			});
	}

	function updateDisplayExpression(items) {
		if (!vm.displayExpression) {
			return $q.when(items);
		}
		return getEntityClassName().then(function (entityClassName) {
			if (externalServiceManager.isService(entityClassName)) {
				return items;
			}

			return $q.all(
				items.map((item) => {
					return vm
						._getFragmentDescriptorsInBatch(
							vm.entityClassName,
							item.Id,
							vm.parentExpression,
							useObjectId,
							undefined,
							undefined,
							vm.displayExpression,
							vm.columnDefinition
						)
						.then(function (data) {
							item.DisplayString = data.DisplayString;
							item._displayName = data.DisplayString;
							return item;
						});
				})
			);
		});
	}

	function getEntityClassName() {
		return vm.columnDefinition ? getClassNameByColumnDefinition() : $q.when(vm.entityClassName);
	}

	function loadItems(searchText, pickerCtrl, items, extraParams) {
		if (items) {
			items.forEach(function (itm) {
				getItemDetails(pickerCtrl, itm);
			});

			return $q.when(items);
		}

		_pickerCtrl = pickerCtrl;

		return getEntityClassName().then(function (entityClassName) {
			if (!entityClassName) {
				return $q.when([]);
			}

			const activeFilter = _resetFilterActive ? resetFilter : filter;
			const requestData = new EntityClassRequest(entityClassName, activeFilter, _loadItemsCount, vm.columnDefinition);

			// const filterExpression = skipFilter ? '' : filter.expression;

			requestData.notStrictAutocomplete = true;
			requestData.parent = vm.parentExpression;
			requestData.rootElement = vm.rootElement;
			requestData.includeRoot = vm.includeRoot;
			requestData.allowedTypes = vm.allowedTypes;
			requestData.displayExpression = vm.displayExpression;
			let extraData = null;

			if (vm.objectId !== 'new') {
				requestData.objectId = vm.objectId;
			} else if (vm.relationName && !vm.reverseRelationIsSet) {
				requestData.relationName = vm.relationName;
				extraData = {};
			}

			requestData.useObjectId = vm.useObjectId;
			requestData.displayString = vm.displayString;

			if (Array.isArray(vm.selectedIds)) {
				requestData.exclude = vm.selectedIds.join(',');
			}

			$.extend(requestData, extraParams);

			return mxEntityService.getFragmentDescriptors(requestData, searchText, extraData).then(function (data) {
				if (extraData !== null) {
					vm.entityClassName = extraData.EntityClass;
					vm.reverseRelationIsSet = true;
				}
				const all = data.length < _loadItemsCount;
				// return {
				// 	items: {}
				// };
				return {
					items: all ? data : data.slice(0, _loadItemsCount - 1),
					searchText: searchText,
					all: all,
				};
			});
		});
	}
}

function getDirectiveDescriptor(ctrl, tagName, extraProps) {
	var directive = new mx.components.FormControlBase(ctrl, null);

	extraProps = extraProps || ' ng-model="vm.model" ';
	directive.template = '<' + tagName + extraProps + commonObjectPickerTemplate + '></' + tagName + '>';

	directive.require = {
		mxForm: '?^mxForm',
		parentViewController: '?^^mxView',
	};
	directive.link = function (scope) {
		var vm = scope.vm;
		vm.tagName = tagName;
	};
	return directive;
}

var commonObjectPickerProperties = {
	entityClassName: '@',
	// filterExpression: '<',
	ngRequired: '=?',
	disabled: '=?',
	required: '=?require',
	dropdownHtmlClass: '@',
	allowResetFilter: '@',
	columnDefinition: '@',
	parentExpression: '@',
	selectedItem: '=?',
	allowedTypes: '@',
	useObjectId: '@',
	noBrowseLookup: '@',
	removable: '<',
	onBlur: '<',
	noLabel: '<',
	displayExpression: '@',
	hideIcon: '<?',
	mxAtId: '@',
};

var commonObjectPickerTemplate =
	'' +
	'data-hide-icon="vm.hideIcon" ' +
	'data-name="{{vm.name}}" ' +
	'data-label="{{vm.label}}" ' +
	'data-hint="{{vm.hint}}" ' +
	'data-item-title-field="DisplayString" ' +
	'data-item-id-field="Id" ' +
	'data-item-details-field="{{::vm.itemDetailsField}}" ' +
	'data-disabled="vm.disabled" ' +
	'read-only="vm.readOnly" ' +
	'ng-required="(vm.required || vm.ngRequired) && !vm.disabled && !vm.readOnly" ' +
	'data-load-items="vm.loadItems" ' +
	'data-load-on-typing="true" ' +
	'data-on-change="vm.onChange()" ' +
	'data-on-blur="::vm.internalOnBlur" ' +
	'data-no-label="vm.noLabel" ' +
	'data-not-found="vm.notFoundDescriptor" ' +
	'data-load-more-config="::vm.loadMoreConfig" ' +
	'data-selected-item="vm.selectedItem" ' +
	'navigate-item="vm.navigateSelectedItem" ' +
	'browse-lookup="vm.browseLookup" ' +
	'data-removable="vm.removable"' +
	'dropdown-html-class="{{::vm.dropdownHtmlClass}}" ' +
	'custom-validation="vm.customValidation"';

/**
 * @ngdoc directive
 * @name mx.components:mxObjectPicker
 * @module mx.components
 * @restrict 'E'
 * @description
 * The mx-object-picker control is used to create a picker where user can select objects in single mode.
 *
 * The example below demonstrates some of the attributes you may use with the ObjectPicker control:
 * @param {string} entityClassName@ - SPS class where data should be loaded from.
 * @param {string} entityAttribute@ - Attribute of SPS class which should be returned.
 * @param {string} filterExpression= - Expression to extract only specific records.
 * @param {string} required= - The required property sets or returns whether a mxObjectPicker must be filled out before submitting a form.
 * @param {string} dropdownHtmlClass@ - This will be applied to the dropdown menu for styling.
 * @param {string} objectId= - Returns Id .
 *
 * @usage <mx-object-picker data-label="Object Picker" ng-model="vm.selectedUser" class="mx-picker-default" dropdown-html-class="mx-object-picker-default-values" data-required="true" data-entity-class-name="SPSUserClassBase" data-filter-expression="vm.filter"></mx-object-picker>
 */
angular.module('mx.SolutionBuilderAgent').directive('mxObjectPicker', function mxObjectPickerDirective() {
	var directive = getDirectiveDescriptor(MxObjectPickerCtrl, 'mx-picker');

	angular.extend(directive.bindToController, commonObjectPickerProperties);
	directive.bindToController.objectId = '=?';
	directive.bindToController.displayString = '=?';

	return directive;
});

function registerHotkeys(scope, element, pickerCtrl, keyboardNavigationService, i18n) {
	var hintsActive, isComboPressed;

	if (!pickerCtrl.browseLookup) {
		return;
	}

	if (!keyboardNavigationService.getKeyOptions('alt+o')) {
		keyboardNavigationService.registerKey({
			scope: scope,
			key: 'alt+o',
			description: i18n.get('solutionBuilderAgent.components.mx-object-picker.lookup'),
			callback: angular.noop,
		});
	}

	element.on('keyup keydown focusout', handleEvent);

	scope.$on('$destroy', function cleanUp() {
		element.off();
	});

	function handleEvent(ev) {
		var type = ev.type;

		switch (type) {
			case 'keydown':
				handleKeyDown(ev);
				break;
			case 'keyup':
				hintsActive = false;
				element.find('.autocomplete-search').attr('hint-key', null);
				break;
			case 'focusout':
				isComboPressed = false;
				break;
			default:
				break;
		}
	}

	function handleKeyDown(ev) {
		if (!ev.altKey || isComboPressed) {
			return;
		}

		var browseBtn = element.find('.autocomplete-search:visible');

		if (!hintsActive) {
			browseBtn.attr('hint-key', 'o');
			hintsActive = true;
		}

		if (ev.key === 'o') {
			if (isComboPressed) {
				return;
			}

			isComboPressed = true;
			browseBtn.click();
		}
	}
}

mx.SolutionBuilderAgent.ObjectPickerCtrl = MxObjectPickerCtrl;
mx.SolutionBuilderAgent.ObjectPicker = {
	getDirectiveDescriptor: getDirectiveDescriptor,
	commonObjectPickerProperties: commonObjectPickerProperties,
};
